<template>
<el-container>

 <el-main> 
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="deviceName" :placeholder="$t('butler.bulter-input')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSelect">{{$t('butler.qurey')}}</el-button>
          <!-- <el-button type="primary" @click="onCreate">增加网关</el-button> -->
        </el-form-item>
    </el-form>
    <template>
    <el-table :data="tableData" @row-dblclick="trDBClick" :header-cell-style="{background:'#eef1f6',color:'#606266'}" empty-text="No Data" border>
        <el-table-column type="index" :label="$t('butler.number')" width="100" align="center"></el-table-column>
        <el-table-column prop="apartmentName" label="公寓名称" align="center"></el-table-column>
        <el-table-column prop="bindTime" label="绑定时间" align="center"></el-table-column>
        <el-table-column prop="deviceId" label="设备ID" align="center"  width="120"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
        <el-table-column prop="deviceType" label="设备类型" align="center" width="120"></el-table-column>
        <el-table-column prop="isOnline" label="在线状态" align="center"></el-table-column>
      </el-table>
    </template>
  </el-main>
  <el-footer>
    <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
    </div>
  </el-footer>    
</el-container>  
</template>
<script>
import Pagings from "../common/Pagings.vue";
import * as echarts from 'echarts';
export default {
  name: "butlerList", //这个LoginName最好和引入的vue的LoginName相同
   data() {
    return {
      deviceName:"",
      isOnline: this.$route.query.isOnline==undefined?"":this.$route.query.isOnline,
      lowBattery:this.$route.query.lowBattery==undefined?"":this.$route.query.lowBattery,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 0, //总条数
      tableData: [],
    };
  },
  components: {
    Pagings
  },
  created() {
    this.power();
  },
  methods: {
    trDBClick(row, event, column){
      var deviceId=row.deviceId;
      this.$router.push({path:'/deviceStaDetail',query: {"deviceId":deviceId}});
    },
    onSelect(){

    },
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      if(this.isOnline!=""&&this.isOnline!=null&&this.isOnline!=undefined){
         formData.append("isOnline",0);
      }
      if(this.isLowBattery!=""&&this.isLowBattery!=null&&this.isLowBattery!=undefined){
         formData.append("batteryLow",1);
      }
      this.$server
        .exam("/customer/lock/listLock", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

   
   
    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/statistics/deviceStaList.vue